export default __webpack_public_path__ + "static/book-bd1b2e618386c9761cacac24437ff730.jpg";